import axios from 'axios'
import { EnvironmentVariable } from './constants'
import { auth } from '@/features/auth/firebaseConfig'
import { getAuthToken } from './getAuthToken'

const { localEnvConfig } = EnvironmentVariable

const HTTPInstanceFastApi = axios.create({
  baseURL: localEnvConfig.CHAT_BOT_API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

HTTPInstanceFastApi.interceptors.request.use(async config => {
  if (auth.currentUser) {
    const token = await getAuthToken()
    config.headers.set('Authorization', `Bearer ${token}`)
  }
  return config
})

export { HTTPInstanceFastApi }
